import {iframeToSdkChannel} from "../messaging/IframeToSdkChannel";
import {IFrameMessages} from "../messaging/IFrameMessages";
import {isDeepEqual} from "../../blinkpay/UtilsLib";
import {Dispatcher} from "../../stem-core/src/base/Dispatcher";
import {merchantLocalStorage, merchantSessionStorage} from "./merchant-state/MerchantStorage";
import {DONATION_COOLDOWN_PERIOD, MERCHANT_STORAGE_KEYS} from "../Constants";
import {allIFrameElements} from "../ui/elements/IFrameElement";


function isActiveRecurringPayment(recurringPayment, cooldownPeriod=0) {
    return recurringPayment
        && recurringPayment.activeUntil
        && Date.now() - (new Date(recurringPayment.activeUntil)).getTime() < cooldownPeriod;
}

function hasActiveDonation(userData) {
    // TODO @Mihai we should also see if there was a recurring donation withing the last DONATION_COOLDOWN_PERIOD as well
    return isActiveRecurringPayment(userData.activeRecurringDonation)
            || isActiveRecurringPayment(userData.latestOneTimeDonation, DONATION_COOLDOWN_PERIOD);
}

// Manages the user authentication info.
class UserDataModule {
    userPreferencesChange = new Dispatcher();
    authenticationChange = new Dispatcher();
    subscriptionChange = new Dispatcher();

    userData = {
        userId: null,
        alwaysShowBalance: null,
        showOnboarding: null,
        subscription: null,
        activeRecurringDonation: null,
        latestOneTimeDonation: null,
        newsletterIds: [],
    };

    init() {
        iframeToSdkChannel.addListener(IFrameMessages.UPDATE_SDK_USER_DATA, ({userData}) => {
            const oldUserData = {...this.userData};

            Object.assign(this.userData, userData);

            if (!isDeepEqual(oldUserData, userData)) {
                this.userPreferencesChange.dispatch();
            }

            if (oldUserData.userId !== userData.userId) {
                this.authenticationChange.dispatch();
            }
            if (!isDeepEqual(oldUserData.subscription, userData.subscription)) {
                this.subscriptionChange.dispatch(userData.subscription);
            }
        });

        iframeToSdkChannel.addListener(IFrameMessages.SET_MERCHANT_TOKEN, ({token}) => this.setMerchantToken(token));
    }

    setMerchantToken(token) {
        if (token) {
            merchantLocalStorage.setItem(MERCHANT_STORAGE_KEYS.authToken, token);
            merchantSessionStorage.setItem(MERCHANT_STORAGE_KEYS.authToken, token);
        } else {
            merchantLocalStorage.removeItem(MERCHANT_STORAGE_KEYS.authToken);
            merchantSessionStorage.removeItem(MERCHANT_STORAGE_KEYS.authToken);
        }
        allIFrameElements.forEach(iFrameElement => {
            iFrameElement.sendMessage(IFrameMessages.UPDATE_MERCHANT_TOKEN, {token});
        });
    }

    isAuthenticated() {
        return this.userData.userId != null;
    }

    isRecurringDonor() {
        return isActiveRecurringPayment(this.userData.activeRecurringDonation);
    }

    isDonor() {
        return hasActiveDonation(this.userData);
    }

    isSubscriber() {
        return isActiveRecurringPayment(this.userData.subscription);
    }
}

export const userDataModule = new UserDataModule();
